/* import __COLOCATED_TEMPLATE__ from './create-subaccount-flow.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, set } from '@ember/object';
import { SavingsAccountMetadata } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { SAVINGS_CATEGORIES_TO_ENUMS } from '@banking/ui/utils/constants';
import multipassStatus from '@banking/api/utils/multipass-status';
import { SmsTwoFactor, TwoFactorDetails } from '@square/dashboard-protos/models/squareup/multipass/common';
import { v4 as uuid } from 'uuid';
import { Error as MPError, VerificationCodeRequest } from '@square/dashboard-protos/models/squareup/multipass/external';
import { Action, getEvent, Target, Page as EventPage, FolderName } from '@banking/ui/utils/folder-cdp-events';
var Page = /*#__PURE__*/function (Page) {
  Page[Page["Tutorial"] = 0] = "Tutorial";
  Page[Page["PhoneNumber"] = 1] = "PhoneNumber";
  Page[Page["VerifyCode"] = 2] = "VerifyCode";
  Page[Page["SelectCategory"] = 3] = "SelectCategory";
  Page[Page["SalesTax"] = 4] = "SalesTax";
  Page[Page["Confirm"] = 5] = "Confirm";
  Page[Page["Success"] = 6] = "Success";
  Page[Page["Error"] = 7] = "Error";
  return Page;
}(Page || {});
const BAD_NUMBER_ERRORS = new Set([MPError.INVALID_ALIAS, MPError.BLOCKED_SMS_NUMBER]);
let CreateSubaccountFlow = (_class = class CreateSubaccountFlow extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "multipassExternalApi", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "dataApi", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
    _defineProperty(this, "categories", SAVINGS_CATEGORIES_TO_ENUMS);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "isButtonLoading", false);
    _defineProperty(this, "page", Page.SelectCategory);
    _defineProperty(this, "showSubflow", false);
    _defineProperty(this, "backToSubflow", false);
    _defineProperty(this, "pages", Page);
    _defineProperty(this, "phoneNumber", '');
    _defineProperty(this, "code", '');
    _defineProperty(this, "error", void 0);
    _defineProperty(this, "showValidation", false);
    _defineProperty(this, "isSendingCode", false);
    this.automationSubaccountState.initializeMerchantWithholdingConfig();
    this.automationSubaccountState.initializeUnitWithholdingConfigs();
    if (this.args.includeTutorial) {
      this.page = Page.Tutorial;
    } else if (this.args.skipSelectCategory && this.args.folderCategory) {
      this.selectSubflow(this.args.folderCategory);
    }
  }
  async check2FAAndProceed() {
    set(this, 'isButtonLoading', true);
    try {
      const {
        name,
        properties
      } = getEvent(Action.Click, {
        page: EventPage.OrganizeMoney,
        target: Target.Next
      });
      this.dataApi.track(name, properties);
      const mpStatus = await multipassStatus();
      if (mpStatus.requiresTwoFactor) {
        set(this, 'page', Page.SelectCategory);
      } else {
        const {
          name,
          properties
        } = getEvent(Action.View, {
          page: EventPage.VerifyPhone
        });
        this.dataApi.track(name, properties);
        set(this, 'page', Page.PhoneNumber);
      }
    } catch {
      set(this, 'page', Page.Error);
    } finally {
      set(this, 'isButtonLoading', false);
    }
  }
  async submitPhone() {
    // TODO: more validations?
    if (this.phoneNumber) {
      set(this, 'isButtonLoading', true);
      try {
        const {
          name,
          properties
        } = getEvent(Action.Click, {
          page: EventPage.VerifyPhone,
          target: Target.SendCode
        });
        this.dataApi.track(name, properties);
        const smsTwoFactorDetails = TwoFactorDetails.create({
          description: this.phoneNumber,
          sms: SmsTwoFactor.create({
            phone: this.canonicalPhone()
          })
        });
        const response = await this.multipassExternalApi.enrollTwoFactor({
          twoFactorDetails: smsTwoFactorDetails,
          idempotenceKey: uuid()
        });
        if (response.error === MPError.NO_ERROR) {
          set(this, 'error', undefined);
          set(this, 'showValidation', false);
          set(this, 'page', Page.VerifyCode);
        } else if (BAD_NUMBER_ERRORS.has(response.error)) {
          const message = this.intl.t('banking.savings.subaccounts.create.twoFactor.phoneError');
          set(this, 'error', message);
          set(this, 'showValidation', true);
        } else {
          throw new Error(MPError[response.error]);
        }
      } catch {
        set(this, 'page', Page.Error);
      } finally {
        set(this, 'isButtonLoading', false);
      }
    } else {
      const message = this.intl.t('banking.savings.subaccounts.create.twoFactor.phoneError');
      set(this, 'error', message);
      set(this, 'showValidation', true);
    }
  }

  // Copied from dashboard/lib/account-settings/app/components/accounts/two-factor/add-method-sms-modal.js
  canonicalPhone() {
    const raw = this.phoneNumber || '';
    let digits = raw.replace(/[^\d+]/g, '');
    if (!/^\+/.test(digits)) {
      digits = `+1${digits}`;
    }
    return digits;
  }
  async resendCode() {
    set(this, 'isSendingCode', true);
    try {
      await this.multipassExternalApi.sendVerificationCode({
        reason: VerificationCodeRequest.Reason.TWO_FACTOR,
        smsPhone: this.phoneNumber,
        locale: this.intl.primaryLocale,
        idempotenceKey: uuid()
      });
    } catch {
      set(this, 'page', Page.Error);
    } finally {
      set(this, 'isSendingCode', false);
    }
  }
  async submitCode() {
    if (this.code && /^\d{6}$/.test(this.code)) {
      set(this, 'isButtonLoading', true);
      try {
        const {
          name,
          properties
        } = getEvent(Action.Click, {
          page: EventPage.VerifyPhone,
          target: Target.Verify
        });
        this.dataApi.track(name, properties);
        const twoFactorDetails = TwoFactorDetails.create({
          sms: SmsTwoFactor.create({
            phone: this.phoneNumber,
            verificationCode: this.code
          })
        });
        const multipassError = await this.enrollTwoFactor(twoFactorDetails);
        if (multipassError === MPError.NO_ERROR) {
          set(this, 'page', Page.SelectCategory);
        } else if (multipassError === MPError.INVALID_CREDENTIALS) {
          const message = this.intl.t('banking.savings.subaccounts.create.twoFactor.codeError');
          set(this, 'error', message);
          set(this, 'showValidation', true);
        } else {
          set(this, 'page', Page.Error);
        }
      } catch {
        set(this, 'page', Page.Error);
      } finally {
        set(this, 'isButtonLoading', false);
      }
    } else {
      const message = this.intl.t('banking.savings.subaccounts.create.twoFactor.codeError');
      set(this, 'error', message);
      set(this, 'showValidation', true);
    }
  }
  async enrollTwoFactor(twoFactorDetails) {
    const response = await this.multipassExternalApi.enrollTwoFactor({
      twoFactorDetails,
      idempotenceKey: uuid()
    });
    return response.error;
  }
  goToPage(page) {
    set(this, 'page', page);
  }
  selectSubflow(category) {
    let folderName;
    if (category === SavingsAccountMetadata.Category.CUSTOM) {
      folderName = FolderName.Custom;
    } else if (category === SavingsAccountMetadata.Category.PAYROLL) {
      folderName = FolderName.Payroll;
    } else if (category === SavingsAccountMetadata.Category.RAINY_DAY) {
      folderName = FolderName.RainyDay;
    } else if (category === SavingsAccountMetadata.Category.RENT) {
      folderName = FolderName.Rent;
    } else if (category === SavingsAccountMetadata.Category.TAX) {
      folderName = FolderName.Taxes;
    } else if (category === SavingsAccountMetadata.Category.EXPENSE) {
      folderName = FolderName.Expense;
    } else if (category === SavingsAccountMetadata.Category.RETIREMENT) {
      folderName = FolderName.Retirement;
    } else if (category === SavingsAccountMetadata.Category.PROFIT) {
      folderName = FolderName.Profit;
    } else if (category === SavingsAccountMetadata.Category.VEHICLE_GAS) {
      folderName = FolderName.VehicleGas;
    } else if (category === SavingsAccountMetadata.Category.GIVING) {
      folderName = FolderName.Giving;
    } else if (category === SavingsAccountMetadata.Category.EDUCATION) {
      folderName = FolderName.Education;
    }
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: EventPage.CreateFolder,
      folderName
    });
    this.dataApi.track(name, properties);
    set(this.automationSubaccountState, 'category', category);
    set(this, 'showSubflow', true);
    set(this, 'backToSubflow', false);
    this.automationSubaccountState.setCategoryDefaults(category);
  }
  goBackToSubflow() {
    set(this, 'showSubflow', true);
    set(this, 'backToSubflow', true);
  }
  get showSalesTaxRow() {
    return this.features.isEnabled('banking-enable-sales-tax-folders') && ((this.args.salesTaxEntries?.length ?? 0) > 0 || this.automationSubaccountState.hasSalesTaxFolder);
  }
  openSalesTaxFlow() {
    set(this, 'page', Page.SalesTax);
  }
  closeSubflow() {
    set(this, 'page', Page.SelectCategory);
    set(this, 'showSubflow', false);
  }
  confirm() {
    set(this, 'page', Page.Confirm);
    set(this, 'showSubflow', false);
  }
  async continue() {
    set(this, 'showSubflow', false);
    try {
      set(this, 'isLoading', true);
      await this.automationSubaccountState.createSubaccount();
      await this.args.onCreate();
      set(this, 'page', Page.Success);
    } catch {
      set(this, 'page', Page.Error);
    } finally {
      set(this, 'isLoading', false);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassExternalApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "check2FAAndProceed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "check2FAAndProceed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectSubflow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSubflow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goBackToSubflow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goBackToSubflow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSalesTaxFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openSalesTaxFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeSubflow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeSubflow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "continue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "continue"), _class.prototype), _class);
export { CreateSubaccountFlow as default };